export class InLinePumps{

    pumpCurve:string
    purposeWaterSupply:string
    dutyFlowPerPump:number;
    noOfDutyPumps:number;
    standbyPumps:number;
    totalDutyFlow:number;
    pumpsOperatingTogether:string

    constructor(obj?: any) {
        if (obj) {
          if (obj.hasOwnProperty('pumpCurve')) {
            this.pumpCurve = obj.pumpCurve
          }
          if (obj.hasOwnProperty('purposeWaterSupply')) {
            this.purposeWaterSupply = obj.purposeWaterSupply
          }
          if (obj.hasOwnProperty('dutyFlowPerPump')) {
            this.dutyFlowPerPump = obj.dutyFlowPerPump;
          }
          if (obj.hasOwnProperty('noOfDutyPumps')) {
            this.noOfDutyPumps = obj.noOfDutyPumps
          }
          if (obj.hasOwnProperty('standbyPumps')) {
            this.standbyPumps = obj.standbyPumps;
          }
          if (obj.hasOwnProperty('totalDutyFlow')) {
            this.totalDutyFlow = obj.totalDutyFlow;
          }
          if (obj.hasOwnProperty('pumpsOperatingTogether')) {
            this.pumpsOperatingTogether = obj.pumpsOperatingTogether;
          }
         
      }
      }
}




// WEBPACK FOOTER //
// ./src/app/shared/data-objects/inLine-pumps.ts